import { render, staticRenderFns } from "./DashboardConversationsCards.vue?vue&type=template&id=3d789cce&"
import script from "./DashboardConversationsCards.vue?vue&type=script&lang=js&"
export * from "./DashboardConversationsCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports